/* eslint-disable default-param-last */
export const types = {
  SEND_RETARGETING: 'FORM_TV/SEND_RETARGETING',
  SET_SEGMENT: 'FORM_TV/SET_SEGMENT',
  INIT_PURCHASE: 'FORM_TV/INIT_PURCHASE',
  INIT_PURCHASE_SUCCESS: 'FORM_TV/INIT_PURCHASE_SUCCESS',
  CHECKOUT_REQUEST: 'FORM_TV/CHECKOUT_REQUEST',
  CHECKOUT_REQUEST_SUCCESS: 'FORM_TV/CHECKOUT_REQUEST_SUCCESS',
  SEND_PURCHASE_OTP: 'FORM_TV/SEND_PURCHASE_OTP',
  VALIDATE_PURCHASE_OTP: 'FORM_TV/VALIDATE_PURCHASE_OTP',
  PROCESS_ORDER: 'FORM_TV/PROCESS_ORDER',
  PROCESS_ORDER_SUCCESS: 'FORM_TV/PROCESS_ORDER_SUCCESS',
};

export const actions = {
  sendRetargeting: (data) => ({
    type: types.SEND_RETARGETING,
    payload: { data },
  }),
  setSegment: (data) => ({
    type: types.SET_SEGMENT,
    payload: { data },
  }),
  initPurchase: (data) => ({
    type: types.INIT_PURCHASE,
    payload: { data },
  }),
  initPurchaseSuccess: (data) => ({
    type: types.INIT_PURCHASE_SUCCESS,
    payload: { data },
  }),
  checkout: (data) => ({
    type: types.CHECKOUT_REQUEST,
    payload: { data },
  }),
  checkoutSuccess: (data) => ({
    type: types.CHECKOUT_REQUEST_SUCCESS,
    payload: { data },
  }),
  sendSmsOtp: (data) => ({
    type: types.SEND_PURCHASE_OTP,
    payload: { data },
  }),
  validateSmsOtp: (data) => ({
    type: types.VALIDATE_PURCHASE_OTP,
    payload: { data },
  }),
  processOrder: (data) => ({
    type: types.PROCESS_ORDER,
    payload: { data },
  }),
  processOrderSuccess: (data) => ({
    type: types.PROCESS_ORDER_SUCCESS,
    payload: { data },
  }),
};

const initialState = {
  segment: null,
  loadingForm: false,
  loadingShoppingCart: false,
  initialShoppingCart: null,
  shoppingCart: null,
  customerInfo: null,
  processingOrder: false,
  checkout: false,
};

function reducer(state = { ...initialState }, action) {
  switch (action.type) {
    case types.SET_SEGMENT: {
      const { data } = { ...action.payload };
      const { segment } = { ...data };
      return {
        ...state,
        segment,
      };
    }
    case types.INIT_PURCHASE: {
      return {
        ...state,
        loadingForm: true,
      };
    }
    case types.INIT_PURCHASE_SUCCESS: {
      const { data } = { ...action.payload };
      const { shoppingCartInfoNormalized, customerInfoNormalized, nextSteps } =
        {
          ...data,
        };
      return {
        ...state,
        loadingForm: false,
        initialShoppingCart: shoppingCartInfoNormalized,
        shoppingCart: shoppingCartInfoNormalized,
        customerInfo: customerInfoNormalized,
        nextSteps,
      };
    }
    case types.CHECKOUT_REQUEST: {
      return {
        ...state,
        checkout: true,
      };
    }
    case types.CHECKOUT_REQUEST_SUCCESS: {
      return {
        ...state,
        checkout: false,
      };
    }
    case types.PROCESS_ORDER: {
      return {
        ...state,
        processingOrder: true,
      };
    }
    case types.PROCESS_ORDER_SUCCESS: {
      return {
        ...state,
        processingOrder: false,
      };
    }
    default:
      return state;
  }
}

export default reducer;
